import { X } from "lucide-react";

export default function Modal({ title, eyebrow, onClose, children, testId }) {
  return (
    <div className="modal-backdrop" onMouseDown={onClose} data-testid={testId || "modal"}>
      <section className="modal" data-edit-name={typeof title === "string" && title.trim() ? title.trim() : "Dialog"} onMouseDown={(e) => e.stopPropagation()}>
        <button className="close" onClick={onClose} data-testid="modal-close">
          <X size={18} />
        </button>
        {eyebrow ? <span className="eyebrow">{eyebrow}</span> : null}
        <h2>{title}</h2>
        {children}
      </section>
    </div>
  );
}
